import { render } from "./addTracksDataTable.vue?vue&type=template&id=40c754b9"
import script from "./addTracksDataTable.vue?vue&type=script&lang=js"
export * from "./addTracksDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__